import BaseTitledCard from 'components/atoms/base-titled-card';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { useState, useEffect } from 'react';
import { CLINIC_CARE_MANAGERS_TABLE_ITEMS_PER_PAGE } from 'constants/clinicCareManagers';
import { getClinicCareManagersGetApiQueryKey } from 'infrastructure/hooks/clinic/use-clinic-care-managers';

import CareManagersTable from '../../care-manager-table';

import type { Clinic } from 'infrastructure/classes/clinic';
import type { IClinicCareManager } from 'infrastructure/interfaces';

interface IResponse {
  count: number;
  items: IClinicCareManager[];
}

interface IProps {
  info: Clinic;
}

const CareAgentsView = ({ info }: IProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState<number>(0);

  const careManagersQueryKey = getClinicCareManagersGetApiQueryKey(
    page,
    CLINIC_CARE_MANAGERS_TABLE_ITEMS_PER_PAGE,
    info.guid,
  );

  useEffect(() => {
    const unsubscribe = queryClient.getQueryCache().subscribe(() => {
      const updatedData =
        queryClient.getQueryData<IResponse>(careManagersQueryKey);
      if (updatedData?.count !== count) {
        setCount(updatedData?.count ?? 0);
      }
    });

    return () => unsubscribe();
  }, [queryClient, careManagersQueryKey, count]);

  return (
    <BaseTitledCard title={`${t('labels.ccmSpecialists')}: ${count}`}>
      <CareManagersTable
        setPage={setPage}
        page={page}
        clinicGuid={info?.guid}
        items={CLINIC_CARE_MANAGERS_TABLE_ITEMS_PER_PAGE}
      />
    </BaseTitledCard>
  );
};

export default CareAgentsView;
